import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';

import validationSchema from 'venuescanner-js/react/components/Form/schemas/enquiry';

import EnquiryEdit from './EnquiryEdit';

import './EnquiryEditForm.scss';

const EnquiryEditForm = ({ thread, onSubmit, onCancel }) => {
  const {
    formState: { errors, isDirty },
    handleSubmit,
    register,
    setValue,
    control,
  } = useForm({
    mode: 'onChange',
    criteriaMode: 'all',
    resolver: yupResolver(validationSchema),
    defaultValues: {
      message: '',
      dateRange: [
        new Date(thread.localDates.from),
        new Date(thread.localDates.to),
      ],
      capacity: parseInt(thread.cumulativeOffer.capacity),
      start: moment(thread.localDates.from).format('HH:mm'),
      end: moment(thread.localDates.to).format('HH:mm'),
    },
  });

  const toEnquiry = formValues => {
    const [startDate, endDate] = formValues.dateRange;

    return {
      _id: thread._id,
      message: formValues.message,
      space: formValues.space,
      offer: {
        inquire_id: thread.cumulativeOffer.inquire_id,
        capacity: formValues.capacity,
        dates: `${moment(startDate).format('D/M/YYYY')} - ${moment(
          endDate,
        ).format('D/M/YYYY')}`,
        hours: `${formValues.start} - ${formValues.end}`,
      },
    };
  };

  const Header = (
    <div className='enquiry__header'>
      <h1 className='enquiry__header-title'>Edit event details</h1>
    </div>
  );

  return (
    <EnquiryEdit
      thread={thread}
      register={register}
      setValue={setValue}
      onSubmit={handleSubmit(formValues => onSubmit(toEnquiry(formValues)))}
      errors={errors}
      onCancel={onCancel}
      control={control}
      header={Header}
      isDirty={isDirty}
    />
  );
};

export default EnquiryEditForm;
